"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointDisabledEventData = void 0;
class EndpointDisabledEventData {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointDisabledEventData.attributeTypeMap;
    }
}
exports.EndpointDisabledEventData = EndpointDisabledEventData;
EndpointDisabledEventData.discriminator = undefined;
EndpointDisabledEventData.attributeTypeMap = [
    {
        "name": "appId",
        "baseName": "appId",
        "type": "string",
        "format": ""
    },
    {
        "name": "appUid",
        "baseName": "appUid",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointId",
        "baseName": "endpointId",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointUid",
        "baseName": "endpointUid",
        "type": "string",
        "format": ""
    },
    {
        "name": "failSince",
        "baseName": "failSince",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=EndpointDisabledEventData.js.map